import { useEffect, useState } from "react";
import { saasApi } from "../api/saasApi";

export function usePlans() {
  const [plans, setPlans] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const FALLBACK_PLANS = [
    {
      id: "starter",
      slug: "starter",
      name: "Starter",
      description: "For small businesses getting started",
      monthly_price_paise: 99900,
      yearly_price_paise: 999900,
      user_limit: 3,
      storage_limit_mb: 1024,
      trial_eligible: true,
      trial_days: 15,
    },
    {
      id: "growth",
      slug: "growth",
      name: "Growth",
      description: "For growing teams with advanced needs",
      monthly_price_paise: 249900,
      yearly_price_paise: 2499900,
      user_limit: 10,
      storage_limit_mb: 5120,
      trial_eligible: true,
      trial_days: 15,
    },
    {
      id: "enterprise",
      slug: "enterprise",
      name: "Enterprise",
      description: "Custom limits and dedicated support",
      monthly_price_paise: 0,
      yearly_price_paise: 0,
      storage_limit_mb: 51200,
      trial_eligible: false,
    },
  ];

  useEffect(() => {
    let mounted = true;
    saasApi
      .getPublicPlans()
      .then((res) => mounted && setPlans(res.data?.length ? res.data : FALLBACK_PLANS))
      .catch(() => {
        if (mounted) {
          setPlans(FALLBACK_PLANS);
          setError("Showing standard pricing — live plans temporarily unavailable");
        }
      })
      .finally(() => mounted && setLoading(false));
    return () => {
      mounted = false;
    };
  }, []);

  return { plans, loading, error };
}
